module.exports = __webpack_public_path__ + "img/Fukka-FukaSeat_L-2543.a06da782.png";